import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles["footer-container"]}>
      <p>&copy; {currentYear} The Rhatigan Family Album</p>
    </footer>
  );
}

export default Footer;
